import { getTopbarMessage } from '@api/topbar-message/topbar-message.service';
import { buttonVariants } from '@ui/components/button/button';
import { VariantProps } from 'class-variance-authority';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { ssManager } from '@shared/utils';

import { useImpersonationMessage } from './use-impersonate-messages';
import { useAccountMessage } from './use-account-messages';
import { TopbarVariants } from './topbar';

export interface TopbarMessageConfiguration {
  title: string;
  ctaLabel: string;
  ctaAction: () => void;
  ctaVariant: VariantProps<typeof buttonVariants>['variant'];
  variant: VariantProps<typeof TopbarVariants>['variant'];
}

export const useTopbarConfiguration = () => {
  const [isTopbarVisible, setIsTopbarVisible] = useState(true);

  const isDashboardWelcomeVisible = ssManager.flag('DASHBOARD_WELCOME_HERO_OPEN');

  const { data } = useQuery({
    queryKey: ['topbar-message'],
    queryFn: () => getTopbarMessage(isDashboardWelcomeVisible),
    retry: false,
  });
  const impersonationMessage = useImpersonationMessage();
  const accountMessage = useAccountMessage(data);

  const topbarData = impersonationMessage || accountMessage;

  useEffect(() => {
    if (data) {
      setIsTopbarVisible(true);
    }
  }, [data]);

  return {
    isTopbarVisible,
    topbarData,
    data,
    setIsTopbarVisible,
  };
};
